// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SYkS","comment":"styles_comment__1Fp_O"};